import React from 'react'
import {TextField, Typography, withStyles} from '@material-ui/core'
import {styles, StyledSlider} from './styles'

const FaultPercentageSlider = ({classes, party, value, onChange, onChangeCommitted, color}) => {
  const handleSliderChange = (_, newValue) => {
    onChange(newValue)
  }

  const handleSliderChangeCommitted = (_, newValue) => {
    onChangeCommitted(newValue)
  }

  const handleInputChange = event => {
    const inputValue = event.target.value.replace(/[^\d]/g, '')

    if (inputValue === '') {
      onChange(null)
      onChangeCommitted(null)
      return
    }

    const newValue = parseInt(inputValue, 10)
    const clampedValue = Math.min(Math.max(newValue, 0), 100)
    onChange(clampedValue)
    onChangeCommitted(clampedValue)
  }

  const handleKeyDown = event => {
    // prevent input of - and .
    if (/^[.-]/.test(event.key)) {
      event.preventDefault()
    }
  }

  return (
    <div className={classes.sliderContainer}>
      <div className={classes.partyRow}>
        <Typography className={classes.partyLabel}>{party}</Typography>
        <TextField
          className={classes.percentageInput}
          value={value === null ? '' : value}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
          type="number"
          InputProps={{
            endAdornment: <Typography variant="body2">%</Typography>,
            inputProps: {
              min: 0,
              max: 100,
              step: 1,
            },
          }}
          placeholder="0"
          variant="outlined"
          size="small"
        />
      </div>
      <div className={classes.sliderSection}>
        <Typography className={classes.percentageLabel}>0%</Typography>
        <StyledSlider
          value={value || 0}
          onChange={handleSliderChange}
          onChangeCommitted={handleSliderChangeCommitted}
          min={0}
          max={100}
          step={1}
          style={{color}}
          valueLabelDisplay="auto"
          valueLabelFormat={value => String(value || 0)}
        />
        <Typography className={classes.percentageLabel}>100%</Typography>
      </div>
    </div>
  )
}

export default withStyles(styles)(FaultPercentageSlider)
